import { enableProdMode, importProvidersFrom } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';


import { environment } from './environments/environment';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideFirebaseApp, initializeApp, getApp } from '@angular/fire/app';
import { environment as environment_1 } from 'src/environments/environment';
import { provideFirestore, initializeFirestore } from '@angular/fire/firestore';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from '@angular/fire/app-check';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { QuillModule } from 'ngx-quill';
import { MatSidenavModule } from '@angular/material/sidenav';
import { SharedModule } from './app/shared/shared.module';
import { TemplateModule } from './app/modules/template/template.module';
import { AppRoutingModule } from './app/app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app/app.component';

/**
 * Eliminates console logs from being active in production mode and toggles production mode on.
 * Currently not eliminating anything but console.logs, but in theory we could disable .info and .trace as well.
 */
// if (environment.production) {
//   enableProdMode()
//   if(!!window) {
//       window.console.log = () => {}
//   }
// }


bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(BrowserModule, 
        // 3rd party
        QuillModule.forRoot(), MatSidenavModule, 
        // Custom
        SharedModule, TemplateModule, AppRoutingModule, 
        // Forms
        FormsModule, ReactiveFormsModule),
        provideHttpClient(withInterceptorsFromDi()),
        provideFirebaseApp(() => initializeApp(environment.firebase)),
        provideFirestore(() => {
            const app = getApp();
            const dbName = environment.firebase.dbName;
            const providedFirestore = initializeFirestore(app, {}, dbName);
            return providedFirestore;
        }),
        provideAuth(() => getAuth()),
        {
            provide: 'appCheck',
            useFactory: () => {
                const app = getApp();
                return initializeAppCheck(app, {
                    provider: new ReCaptchaEnterpriseProvider('6LfWlk8qAAAAAL5AutlOnTRxN3ke3-FUwVNoFyXW'), // Your reCAPTCHA key
                    isTokenAutoRefreshEnabled: true, // Automatically refresh App Check token every hour
                });
            }
        },
        provideAnimations()
    ]
})
  .catch(err => console.error(err));
